import React from "react";
import PropTypes from "prop-types";
import { Box, MenuItem, TextField, InputAdornment, Icon } from "@mui/material";

function SelectField({ displayName, fieldRef, options }) {
  return (
    <Box mt={1}>
      <TextField
        select
        fullWidth
        name={fieldRef}
        label={displayName}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>checklist</Icon>
            </InputAdornment>
          ),
        }}
      >
        {options.map((option) => (
          <MenuItem value={option.value}>{option.name}</MenuItem>
        ))}
      </TextField>
    </Box>
  );
}

// Typechecking props of the Transaction
SelectField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

SelectField.defaultProps = {
  options: null,
};
export default SelectField;
